export const OWNERSHIP_DEFAULTS = {
  DECK: {
    is_owned: false,
  },
  TRADE_BINDER: {
    is_owned: true,
  },
  WISHLIST: {
    is_owned: false,
  },
  COLLECTION: {
    is_owned: true,
  },
};

export const getOwnershipDefault = (collectionType) => {
  const defaults = OWNERSHIP_DEFAULTS[collectionType];
  if (!defaults) {
    return { is_owned: OWNERSHIP_DEFAULTS.COLLECTION.is_owned };
  }
  return defaults;
};

export const CARD_FORM_DEFAULTS = {
  quantity: 1,
  condition: 'NM',
  finish: 'nonfoil',
  purchase_price: '',
  notes: '',
  is_commander: false,
  is_sideboard: false,
  is_signature_spell: false,
  is_proxy: false,
};
